var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal-overlay",
      attrs: {
        role: "dialog",
        "aria-modal": "true",
        "aria-label": "Winter Places"
      },
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("div", { staticClass: "modal" }, [
        _c("header", { staticClass: "modal-header" }, [
          _c("h2", { staticClass: "modal-title" }, [
            _vm._v(_vm._s(_vm.$t("modals.newbookingmodal.winter_place.title")))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "icon-btn",
              attrs: { "aria-label": "Close" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_vm._v("✕")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "canvasWrap",
            staticClass: "canvas-wrap",
            style:
              _vm.bgNaturalW && _vm.bgNaturalH
                ? { aspectRatio: _vm.bgNaturalW + " / " + _vm.bgNaturalH }
                : {}
          },
          [
            _c("canvas", {
              ref: "editorCanvas",
              attrs: { id: "marinaPictureCanvas" }
            })
          ]
        ),
        _vm._v(" "),
        _c("footer", { staticClass: "modal-footer" }, [
          _c(
            "button",
            {
              staticClass: "ui primary button",
              attrs: { "aria-label": "Reset view" },
              on: { click: _vm.resetView }
            },
            [
              _vm._v(
                _vm._s(_vm.$t("modals.newbookingmodal.winter_place.reset_view"))
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "ui red button",
              attrs: { "aria-label": "Close" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [
              _vm._v(
                _vm._s(_vm.$t("modals.newbookingmodal.winter_place.close"))
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a1a764c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1a764c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/booking/WinterPlaceModal.vue
// module id = s4i6
// module chunks = 1